function createEmptyRecordsDiff() {
  return { added: {}, updated: {}, removed: {} };
}
function reverseRecordsDiff(diff) {
  const result = { added: diff.removed, removed: diff.added, updated: {} };
  for (const [from, to] of Object.values(diff.updated)) {
    result.updated[from.id] = [to, from];
  }
  return result;
}
function isRecordsDiffEmpty(diff) {
  return !hasAnyKey(diff.added) && !hasAnyKey(diff.updated) && !hasAnyKey(diff.removed);
}
function hasAnyKey(obj) {
  for (const _ in obj) return true;
  return false;
}
function squashRecordDiffs(diffs, options) {
  const result = options?.mutateFirstDiff ? diffs[0] : { added: {}, removed: {}, updated: {} };
  squashRecordDiffsMutable(result, options?.mutateFirstDiff ? diffs.slice(1) : diffs);
  return result;
}
function squashRecordDiffsMutable(target, diffs) {
  for (const diff of diffs) {
    const targetHasRemoved = hasAnyKey(target.removed);
    for (const _id in diff.added) {
      const id = _id;
      const value = diff.added[id];
      if (targetHasRemoved && target.removed[id]) {
        const original = target.removed[id];
        delete target.removed[id];
        if (original !== value) {
          target.updated[id] = [original, value];
        }
      } else {
        target.added[id] = value;
      }
    }
    const targetHasAdded = hasAnyKey(target.added);
    for (const _id in diff.updated) {
      const id = _id;
      const to = diff.updated[id][1];
      if (targetHasAdded && target.added[id]) {
        target.added[id] = to;
        delete target.updated[id];
        if (targetHasRemoved) delete target.removed[id];
        continue;
      }
      const existing = target.updated[id];
      if (existing) {
        existing[1] = to;
        if (targetHasRemoved) delete target.removed[id];
        continue;
      }
      target.updated[id] = [diff.updated[id][0], to];
      if (targetHasRemoved) delete target.removed[id];
    }
    for (const _id in diff.removed) {
      const id = _id;
      if (target.added[id]) {
        delete target.added[id];
      } else if (target.updated[id]) {
        target.removed[id] = target.updated[id][0];
        delete target.updated[id];
      } else {
        target.removed[id] = diff.removed[id];
      }
    }
  }
}
export {
  createEmptyRecordsDiff,
  hasAnyKey,
  isRecordsDiffEmpty,
  reverseRecordsDiff,
  squashRecordDiffs,
  squashRecordDiffsMutable
};
//# sourceMappingURL=RecordsDiff.mjs.map
